var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBatteryEmpty = function SvgIconBatteryEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.5 6.75a2.5 2.5 0 0 0-2.5-2.5H4.125a2.5 2.5 0 0 0-2.5 2.5v10.5a2.5 2.5 0 0 0 2.5 2.5H18a2.5 2.5 0 0 0 2.5-2.5zm-2.5-.5a.5.5 0 0 1 .5.5v10.5a.5.5 0 0 1-.5.5H4.125a.5.5 0 0 1-.5-.5V6.75a.5.5 0 0 1 .5-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.875 9a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0z"
  }))));
};
export default SvgIconBatteryEmpty;